export const routes = [
    {
        name: 'Index',
        path: '/',
        component: () => import('./components/Index.vue'),
    }, {
        name: 'Category',
        path: '/category',
        component: () => import('./components/Category.vue'),
    }, {
        name: 'Daily',
        path: '/daily',
        component: () => import('./components/Daily.vue'),
    }, {
        name: 'Score',
        path: '/score',
        component: () => import('./components/Score.vue'),
    }, {
        name: 'Tag',
        path: '/tag',
        component: () => import('./components/Tag.vue'),
    }, {
        name: 'Rookie',
        path: '/rookie',
        component: () => import('./components/Rookie.vue'),
    }, {
        name: 'Update',
        path: '/update',
        component: () => import('./components/Update.vue'),
    }, {
        name: 'Achievement',
        path: '/achievement',
        component: () => import('./components/Achievement/Index.vue'),
    }, {
        name: 'DailyChallenge',
        path: '/daily-challenge',
        component: () => import('./components/DailyChallenge.vue'),
    }, {
        name: 'Cover',
        path: '/cover',
        component: () => import('./components/Cover.vue'),
    }, {
        name: 'Collection',
        path: '/collection',
        component: () => import('./components/Collection.vue'),
    }, {
        name: 'PartTime',
        path: '/part-time',
        component: () => import('./components/PartTime.vue'),
    }, {
        name: 'Metric',
        path: '/metric',
        component: () => import('./components/Metric.vue'),
    },{
        name: 'Popup',
        path: '/popup',
        component: () => import('./components/Popup.vue'),
    }, {
        name: 'Carousel',
        path: '/carousel',
        component: () => import('./components/Carousel.vue'),
    }, {
        name: 'Subscription',
        path: '/subscription',
        component: () => import('./components/Subscription.vue'),
    }, {
        name: 'NewbieSales',
        path: '/newbie-sales',
        component: () => import('./components/NewbieSales.vue'),
    }, {
        name: 'MiIndex',
        path: '/mi-index',
        component: () => import('./mi/Index.vue'),
    },
];
